import { render, staticRenderFns } from "./ProjectAll.vue?vue&type=template&id=3137d876&scoped=true"
import script from "./ProjectAll.vue?vue&type=script&lang=js"
export * from "./ProjectAll.vue?vue&type=script&lang=js"
import style0 from "./ProjectAll.vue?vue&type=style&index=0&id=3137d876&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137d876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3137d876')) {
      api.createRecord('3137d876', component.options)
    } else {
      api.reload('3137d876', component.options)
    }
    module.hot.accept("./ProjectAll.vue?vue&type=template&id=3137d876&scoped=true", function () {
      api.rerender('3137d876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/ProjectAll.vue"
export default component.exports